import logo from "assets/images/dark_logo.png";
import PaddingX from "layouts/PaddingX";
import { NavLink, useLocation, Link } from "react-router-dom";
import useAuthStore from "store/authStore";
import useLogout from "api/UserResource/useLogout";
import Cart from "./Cart/Cart";
import CurrencyConverter from "./CurrencyConverter";
import MobileMenu from "./MobileMenu";
import ProfileIcon from "./ProfileIcon";
import useNavigationLinks from "./useNavigationLinks";
import NotificationBell from "components/NotificationBell";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BiPowerOff } from "react-icons/bi";
import "./header.css";
import AuthLink from "components/v2/Auth/AuthLink";

const Header = () => {
	const { pathname } = useLocation();
	const isAuthenticated = useAuthStore((state) => state.loggedIn);
	const menu = useNavigationLinks();
	const { mutateAsync, isLoading } = useLogout();
	const navigation = menu.filter((item) => !item.to.includes("auth="));
	const navigationLabel = (item) =>
		({ Books: "Browse books", Subscribe: "Plans", "My Library": "My library" }[item.label] || item.label);

	return (
		<header id="site-header" className="site-header safe-area-inset-top">
			<PaddingX>
				<div className="site-header-mobile">
					<NavLink to="/" className="site-header-logo">
						<img src={logo} alt="Akello Library" width={80} />
					</NavLink>
					<div className="site-header-utilities">
						{isAuthenticated ? (
							<Link to="/my-library" className="site-header-access">
								My library
							</Link>
						) : (
							<AuthLink mode="login" className="site-header-access">
								Sign in
							</AuthLink>
						)}
						<NotificationBell isAuthenticated={isAuthenticated} />
						<Cart />
						<MobileMenu isAuthenticated={isAuthenticated} />
					</div>
				</div>
				<div className="site-header-desktop">
					<NavLink to="/" className="site-header-logo">
						<img src={logo} alt="Akello Library" width={80} />
					</NavLink>
					<nav className="site-header-links" aria-label="Main navigation">
						{navigation.map((item) => (
							<Link
								key={item.to}
								to={item.to}
								aria-current={pathname === item.to ? "page" : undefined}
							>
								{navigationLabel(item)}
							</Link>
						))}
						{!isAuthenticated && (
							<>
								<Link to="/#how-it-works">How it works</Link>
								<Link to="/downloads" aria-current={pathname === "/downloads" ? "page" : undefined}>Get the app</Link>
							</>
						)}
					</nav>
					<div className="site-header-utilities">
						<CurrencyConverter />
						{isAuthenticated && <ProfileIcon />}
						<NotificationBell isAuthenticated={isAuthenticated} />
						<Cart />
						{!isAuthenticated && (
							<div className="site-header-auth">
								<AuthLink mode="login">Sign in</AuthLink>
								<AuthLink mode="register" type="individual" className="site-header-register">
									Create account
								</AuthLink>
							</div>
						)}
						{isAuthenticated && (
							<button
								type="button"
								onClick={() => mutateAsync()}
								disabled={isLoading}
								title="Logout"
								aria-label="Logout"
								className="site-header-icon text-akgreenest disabled:opacity-50"
							>
								{isLoading ? (
									<AiOutlineLoading3Quarters size={28} className="animate-spin" />
								) : (
									<BiPowerOff size={28} />
								)}
							</button>
						)}
					</div>
				</div>
			</PaddingX>
		</header>
	);
};
export default Header;
